import { render, staticRenderFns } from "./SystemRoles.vue?vue&type=template&id=ea8ceaaa&scoped=true"
import script from "./SystemRoles.vue?vue&type=script&lang=js"
export * from "./SystemRoles.vue?vue&type=script&lang=js"
import style0 from "./SystemRoles.vue?vue&type=style&index=0&id=ea8ceaaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8ceaaa",
  null
  
)

export default component.exports